<template lang="pug">
  .modal.is-active(key="modal-editar")

    transition(name='fade-quick')
      .overlay-class(
        v-if="mostrarModalAdjuntar"
      )
        upload-image(
          name="adjuntar_funcion",
          folder="funciones",
          :onlyPdf="true",
          @save="guardarAdjunto"
          @close="closeModalAdjuntar"
        )
          span(slot="title") Adjuntar Funcion
          span(slot="explanation") Adjunta el archivo pdf que contiene la funcion
          span(slot="dropzoneDescription") Arrastra el pdf que desees cargar o dale click al recuadro para buscar en tus archivos
          i(slot="topIcon").fa.fa-file-pdf-o

    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="cargo") Editar funcion
          span(v-else) Crear funcion
        span.icon.close.pointer(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title
          .control.margin-bottom-10
            p.margin-bottom-5 Cargo
            input.input.w-300(
              type="text",
              v-model="cargoLocal"
              :disabled="isLoading"
            )
          .display-flex.text-center.jc-center
            div
              template(v-if="pathPdf")
                template(v-if="pathPdf.startsWith('http')")
                  a.button.is-small(:href="pathPdf", target="_blank")
                    span.icon.is-small
                      i.fa.fa-paperclip.is-small
                    span Ver adjunto
                template(v-else)
                  button.button.is-small(type="button", @click="verAdjuntoLegacy")
                    span.icon.is-small
                      i.fa.fa-paperclip.is-small
                    span Ver adjunto
              template(v-else)
                button.button.is-small.is-primary(@click="openModalAdjuntar")
                  span.icon.is-small
                    i.fa.fa-upload.is-small
                  span Adjuntar

            span.icon.color-red.margin-left-5.cursor-pointer(v-if="pathPdf", @click="pathPdf = ''", tittle="Borrar adjunto")
              i.fa.fa-trash



      footer.card-footer
        a.card-footer-item.is-success(@click="guardar")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import UploadImageComponent from './Component_Upload_Image'
export default {
  name: 'solicitud_vacaciones_component',
  components: {
    'upload-image': UploadImageComponent
  },
  props: ['cargo'],
  data () {
    return {
      pathPdf                 : '',
      isSaving             : false,
      mostrarModalAdjuntar : false,
      isLoading            : false,
      cargoLocal           : ''
    }
  },
  mounted () {
    var vm = this
    if (vm.cargo) {
      vm.cargoLocal = vm.cargo
      vm.fetch()
    }
  },
  methods: {
    verAdjuntoLegacy () {
      let url = process.env.API_ROUTE + '/funciones_pdf/mostrarPath?ruta=' + this.pathPdf
      window.open(url, '_blank')
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        cargo: vm.cargo || vm.cargoLocal
      }

      apiGet(vm, '/funciones_pdf/obtener/funcion', obj, function (data) {
        vm.pathPdf = data.funcion.pathPdf
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar () {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
        cargo: vm.cargoLocal,
        pathPdf: vm.pathPdf
      }

      apiPost(vm, '/funciones_pdf', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    seleccionarEmpleado (o) {
      this.codigoEmpleado = o.codigo
      this.empleadoExcepcion = {}
      this.asignarEmpleadoExcepcion()
    },
    asignarEmpleadoExcepcion () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/vacaciones/empleado/uno/' + this.codigoEmpleado, obj, function (data) {
        vm.empleadoExcepcion = data.data
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    guardarAdjunto (fileSubido) {
      var vm = this
      vm.closeModalAdjuntar()
      vm.pathPdf = fileSubido.file.ruta
    },
    openModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = true
    },
    closeModalAdjuntar () {
      var vm = this
      vm.mostrarModalAdjuntar = false
    },
    emitClose () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .pointer
    cursor pointer
  .solicitud-vacaciones
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;
</style>



// WEBPACK FOOTER //
// Component_Administrador_Funciones_Editar.vue?5004a3d6